import React from "react";
import "./JoinCommunity.css";

const JoinCommunity = () => {
  return (
    <section className="join-community">
      <div className="join-container">
        {/* Left Side - Text Content */}
        <div className="join-text">
          <h2 className="join-heading">
            Be Part of the <span>MBR Network’s</span> Family —
            <br /> Where Every Career Begins!
          </h2>
          <p className="join-desc">
            At <strong>MBR Network’s</strong>, we’re building a powerful
            community of freshers, professionals, and mentors — all focused on
            one goal: helping every student get placed with confidence and
            skills. Join us to access free resources, expert insights, and
            real-time job updates that shape your career journey.
          </p>

          <a
            href="https://www.linkedin.com" // replace later with your LinkedIn community link
            target="_blank"
            rel="noopener noreferrer"
            className="join-btn"
          >
            🌐 Join Now
          </a>
        </div>

        {/* Right Side - Image Collage */}
        <div className="join-images">
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
            alt="Students Working Together"
            className="join-img img1"
          />
          <img
            src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
            alt="Handshake"
            className="join-img img2"
          />
          <img
            src="https://images.unsplash.com/photo-1551434678-e076c223a692"
            alt="Team Collaboration"
            className="join-img img3"
          />
        </div>
      </div>
    </section>
  );
};

export default JoinCommunity;
